import DownloadIcon from "@mui/icons-material/SaveAltRounded";
import { IconButton, Stack } from "@mui/material";
import type { FundraisingDocument } from "../../../../api/types/fundStructureTypes";
import useClientContext from "../../../../context/useClientContext";
import AnalyticsIcon from "@entrilia/shared/icons/AnalyticsIcon";

interface ActionsCellProps {
  row: FundraisingDocument;
  onNavigateToDocumentActivity?: (row: FundraisingDocument) => void;
  onDownloadClick: (row: FundraisingDocument) => void;
}

export const ActionsCell = ({ row, onNavigateToDocumentActivity, onDownloadClick }: ActionsCellProps) => {
  const { hasPermissions } = useClientContext();

  const hasAccessToDocumentActivity = hasPermissions(["ViewInvestorPortalDocumentViewsAnalytics"]);

  return (
    <Stack direction="row" spacing={0.5} sx={{ width: "100%", justifyContent: "flex-end" }}>
      {hasAccessToDocumentActivity && onNavigateToDocumentActivity && (
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            onNavigateToDocumentActivity(row);
          }}
        >
          <AnalyticsIcon />
        </IconButton>
      )}
      <IconButton
        onClick={(e) => {
          e.stopPropagation();
          onDownloadClick(row);
        }}
      >
        <DownloadIcon />
      </IconButton>
    </Stack>
  );
};
